import styled from 'styled-components';
import { theme } from '../../styles/theme';
const avatarSize = '36px';
export const Wrapper = styled.div `
  ${theme.typography.headingXS};
  align-items: center;
  background: ${({ $color }) => $color === 'brandPrimary'
    ? theme.colors.backgroundBrand
    : theme.colors.backgroundBrandSecondary};
  border-radius: 50%;
  color: ${({ $color }) => $color === 'brandPrimary' ? theme.colors.textInverted : theme.colors.text};
  cursor: default;
  display: flex;
  height: ${avatarSize};
  justify-content: center;
  text-transform: uppercase;
  width: ${avatarSize};

  svg {
    font-size: 24px;
  }
`;
